import { render, staticRenderFns } from "./OrganizationsTreeItem.vue?vue&type=template&id=1744f8c8&"
import script from "./OrganizationsTreeItem.vue?vue&type=script&lang=ts&"
export * from "./OrganizationsTreeItem.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizationsTreeItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports